import React, { useState, useRef } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import * as Constants from '../../../../constants';
import { db } from '../../../../config/Fire';
import LoadingPage from '../../../components/LoadingPage';
import { Divider } from 'antd';
import Search from 'antd/lib/input/Search';
import TableClientsSurveys from '../../../containers/TableClientsSurveys';
import './styles.css';

const usersRef = db.ref(`${Constants.MAIN_NODES.USERS}`).orderByChild("userType").equalTo("CLIENT");
const surveysRef = db.ref(`${Constants.MAIN_NODES.SURVEYS_ASSIGNED}`);

function compareName( a, b ) {
    const nameA = a.name.toLowerCase()
    const nameB = b.name.toLowerCase()
    if ( nameA < nameB ) {
      return -1;
    }
    if ( nameA > nameB ) {
      return 1;
    }
    return 0;
}

const SurveysUsers = () => {
    const searchInput = useRef(null)
    const [usersMap, setUsersMap] = useState(null)
    const [usersFiltered, setUsersFiltered] = useState(null)
    const [surveysAssigned, setSurveysAssigned] = useState(null)

    const getData = () => {
        usersRef.on("value", (usersSnap) => {
            const usersLoaded = {}
            if(usersSnap.exists() && usersSnap.val() !== null) {
                usersSnap.forEach(userSnap => {
                    const user = userSnap.val()
                    // Excluir usuarios de tipo ADMIN y REGISTER
                    if(user.userType && user.id && 
                       user.userType !== Constants.USER_TYPES.ADMIN && 
                       user.userType !== Constants.USER_TYPES.REGISTER) {
                        usersLoaded[user.id] = user
                    }
                });
            }
            if(searchInput && searchInput.input) {
                searchInput.input.state.value = ""
            }
            setUsersMap(usersLoaded)
            setUsersFiltered(null)
        })
        surveysRef.on("value", (surveySnap) => {
            let surveysAssignedLoaded = {};
            if(surveySnap.exists() && surveySnap.val() !== null) {
                surveysAssignedLoaded = surveySnap.val()
                setSurveysAssigned(surveysAssignedLoaded)
            }
        })
        return (<LoadingPage />)
    }

    const renderUsersTable = usersFiltered => {
        var data = [];
        Object.keys(usersFiltered).forEach(userKey => {
            const user = usersFiltered[userKey]
            data.push({
                ...user,
                id: user.id,
                name: user.name,
                email: user.email,
                phone: user.phone,
                userType: Constants.userTypesMap[user.userType],
                createDate: user.createDate,
                enabled: user.enabled });
        });
        data.sort(compareName);
        return( <TableClientsSurveys data={data} surveysAssigned={surveysAssigned} /> )
    }

    const searchUser = (value) => {
        if(usersMap) {
            var usersData = [];
            for (var key in usersMap) {
                if(value === "" || (usersMap[key] && usersMap[key].name && usersMap[key].name.toLowerCase().indexOf(value.toLowerCase()) !== -1) || (usersMap[key] && usersMap[key].email && usersMap[key].email.toLowerCase().indexOf(value.toLowerCase()) !== -1)) {
                    usersData.push(usersMap[key]);
                }
            }
            usersData.sort(compareName);
            setUsersFiltered(usersData)
        }
    }

    return (
        <div>
            {
                usersMap ?
                    <Grid>
                        <Divider>Clientes</Divider>
                        <Row center="xs">
                            <Col xs={10} sm={6}>
                                <Search ref={searchInput} style={{ marginBottom: '20px'}} placeholder="Nombre o correo electrónico del usuario" onSearch={(value) => searchUser(value)} enterButton />
                            </Col>
                        </Row>
                        <Row center="xs">
                            <Col xs={12}>
                                {
                                    usersFiltered === null ?
                                        searchUser("")
                                        :
                                        renderUsersTable(usersFiltered)
                                }
                            </Col>
                        </Row>
                    </Grid>
                    :
                    getData()
            }
        </div>
    )
}

export default SurveysUsers;
